import { useTranslation } from 'react-i18next'

import { CaretRightIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Divider, Text } from '@reveni-io/reveni-ui'

import { formatOrderDate, getProductCountLabel } from '@/helpers'
import { getCustomDomain } from '@/helpers/customDomain/customDomain'

import * as Styles from './styles'

const ReturnGroup = ({ orders, customerEmail, storeSlug }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const getNumberOfItems = (lineItems, lineItemGroups) => {
    return getProductCountLabel(t, (lineItems?.length || 0) + (lineItemGroups?.length || 0))
  }

  const getVariantsText = variants => {
    if (variants && Object.values(variants).length) {
      return `| ${Object.values(variants).join(' · ')}`
    }
  }

  const getOrderLink = order => {
    const customDomain = getCustomDomain()

    if (customDomain) {
      return `/?orderNumber=${order.number}&orderEmail=${customerEmail}&joinGroup=true`
    } else {
      return `/${storeSlug}/?orderNumber=${order.number}&orderEmail=${customerEmail}&joinGroup=true`
    }
  }

  if (!orders?.length || orders?.length === 1) return null

  return (
    <>
      <Styles.MainContainer>
        <Divider />
        <Styles.InfoContainer>
          <Text type="titleM">{t('¿Quieres devolver productos de varios pedidos juntos?')}</Text>
          <Text type="bodyMRegular">
            {t(
              'Haz click en uno de estos pedidos para empezar, mete todo en una misma caja y usa la misma etiqueta de devolución.'
            )}
          </Text>
        </Styles.InfoContainer>
        <Styles.OrdersContainer>
          {orders?.map(order => (
            <Styles.OrderContainer key={order.id} href={getOrderLink(order)} target="_blank" rel="noopener noreferrer">
              <Styles.OrderHeaderContainer>
                <Styles.OrderNameContainer>
                  <Text type="titleM" color={theme.colors.primary.tone900}>
                    {order.name}
                  </Text>
                  <Text type="bodyMRegular" color={theme.colors.grey.tone500}>
                    {formatOrderDate(order.external_created_at, i18n.language)}
                  </Text>
                </Styles.OrderNameContainer>
                <div>
                  <CaretRightIcon />
                </div>
              </Styles.OrderHeaderContainer>
              <Styles.ProductsContainer>
                <div>
                  <Text type="bodyMRegular">{getNumberOfItems(order?.line_items, order?.line_item_groups)}</Text>
                  <Styles.ProductsList>
                    {order?.line_items?.slice(0, 10).map(item => (
                      <li key={item.id}>
                        <Text key={item.id} type="bodySRegular">
                          {item?.product?.name} {getVariantsText(item?.variant?.options)}
                        </Text>
                      </li>
                    ))}
                    {order?.line_items?.length > 10 && (
                      <li>
                        <Text type="bodySRegular">
                          {t('y {{moreItems}} más', { moreItems: order?.line_items?.length - 10 })}
                        </Text>
                      </li>
                    )}
                  </Styles.ProductsList>
                </div>
              </Styles.ProductsContainer>
            </Styles.OrderContainer>
          ))}
        </Styles.OrdersContainer>
      </Styles.MainContainer>
    </>
  )
}

export default ReturnGroup
